import React from 'react';
import PropTypes from 'prop-types';
import { BasicInput, BaasicRecaptcha, BaasicButton } from 'core/components';
import { defaultTemplate } from 'core/hoc';

function PasswordRecoveryTemplate({ currentView, t }) {
    const { form, loading, onVerifyRecaptcha, goToLogin } = currentView;
    return (
        <section>
            <div className='login__top'>
                <img className='login__top__logo' src={require('themes/assets/img/logo.svg')} alt='Logo' />
            </div>
            <div className='container--login'>
                <form className='form card card--lrg card--primary' onSubmit={form.onSubmit}>
                    <h1 className='u-mar--bottom--med'>{t('PASSWORD_RECOVERY.TITLE')}</h1>
                    <div className='form__group u-mar--bottom--med'>
                        <BasicInput field={form.$('email')} />
                    </div>
                    <div className='form__group u-mar--bottom--med'>
                        <BaasicRecaptcha verifyCallback={onVerifyRecaptcha} />
                    </div>
                    {
                        form.error && (
                            <div>
                                <p className='type--color--warning'>{form.error}</p>
                            </div>
                        )
                    }
                    <div className='u-group u-mar--bottom--med'>
                        <div className='u-pull'>
                            <BaasicButton className='btn btn--base btn--primary' type='submit' label={t('PASSWORD_RECOVERY.RESET_BUTTON')} disabled={form.submitting || form.validating} />
                        </div>
                        <div className='u-push'>
                            <a className='btn btn--link btn--base btn--base--link u-mar--top--tny display--ib' onClick={goToLogin}>{t('PASSWORD_RECOVERY.CANCEL_BUTTON')}</a>
                        {loading && <span className='btn btn--link btn--base u-push'>{t('PASSWORD_RECOVERY.LOGGING_IN')}</span>}
                        </div>
                    </div>
                    <div className="u-separator--primary u-mar--top--sml u-mar--bottom--med"></div>
                    <p className='u-mar--bottom--med type--color--opaque'>
                        {t('PASSWORD_RECOVERY.DESCRIPTION')}
                    </p>
                </form>
            </div>
        </section>
    )
}

PasswordRecoveryTemplate.propTypes = {
    currentView: PropTypes.object.isRequired,
    t: PropTypes.func
 };

export default defaultTemplate(PasswordRecoveryTemplate);
